import MedicationHistoryConfig from "@/views/configs/medication_history/index.vue";

export default [
  {
    path: "historia-medicamentosa",
    name: "História medicamentosa",
    component: MedicationHistoryConfig,
  },
];
